import React from "react";
import { Button } from "@material-ui/core";
import { NavLink } from "react-router-dom";
const Notifications = ({ notificationsData, isActive }) => {
  // const handleNotification = (id)=>{
  //   const house = localStorage.getItem("house")
  //   if(!house){
  //     localStorage.setItem("house",JSON.stringify([id]));
  //   }else{
  //     const data = JSON.parse(house)
  //     data.push(id)
  //     localStorage.setItem("house",JSON.stringify(data));
  //   }
  // }
  // const check = (id)=>{
  //   const house = localStorage.getItem("house")

  // }
  return (
    notificationsData[0].data.length !== 0 &&
    notificationsData[0].data.map((deta, index) => (
      <div key={deta.gharId} className="pb-2">
        <NavLink
          // to={{
          //   pathname: '/profile',
          //   state: { gharId: houseid },
          // }}
          to={{
            pathname: "/profile",
            state: { gharId: deta.gharId },
          }}
        >
          <Button
            style={{
              fontSize: "0.625rem",
              color: "white",
              borderRadius: "40px 0px 60px 40px",
              backgroundColor: index > 3 ? "#C0C2C6" : "#779EF9",
              textOverflow: "ellipsis",
            }}
            // onClick={()=>handleNotification(houseid)}
          >
            {deta.gharId}
            {deta.member.name}
            {deta.family.phone}
            {deta.vaccine.vaccine}
          </Button>
        </NavLink>
      </div>
    ))
  );
};
export default Notifications;
